var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 35,
    viewBox: "0 0 27 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.71875 35V0.875H12.6719C16.8125 0.875 19.9531 1.67188 22.0938 3.26562C24.2344 4.84375 25.3047 7.16406 25.3047 10.2266C25.3047 11.8984 24.875 13.375 24.0156 14.6562C23.1562 15.9219 21.9609 16.8516 20.4297 17.4453C22.1797 17.8828 23.5547 18.7656 24.5547 20.0938C25.5703 21.4219 26.0781 23.0469 26.0781 24.9688C26.0781 28.25 25.0312 30.7344 22.9375 32.4219C20.8438 34.1094 17.8594 34.9688 13.9844 35H0.71875ZM7.75 20.1406V29.3516H13.7734C15.4297 29.3516 16.7188 28.9609 17.6406 28.1797C18.5781 27.3828 19.0469 26.2891 19.0469 24.8984C19.0469 21.7734 17.4297 20.1875 14.1953 20.1406H7.75ZM7.75 15.1719H12.9531C16.5 15.1094 18.2734 13.6953 18.2734 10.9297C18.2734 9.38281 17.8203 8.27344 16.9141 7.60156C16.0234 6.91406 14.6094 6.57031 12.6719 6.57031H7.75V15.1719Z",
    fill: "url(#paint0_diamond)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.2424 16.8929) rotate(88.0754) scale(45.1147 45.0815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BF2E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB);
export default __webpack_public_path__ + "static/media/B.6102df74b19b4cf30ece3cf2d226af0f.svg";
export { ForwardRef as ReactComponent };